import { render, staticRenderFns } from "./ModalTermos.vue?vue&type=template&id=2bdda39c&scoped=true"
import script from "./ModalTermos.vue?vue&type=script&lang=js"
export * from "./ModalTermos.vue?vue&type=script&lang=js"
import style0 from "./ModalTermos.vue?vue&type=style&index=0&id=2bdda39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdda39c",
  null
  
)

export default component.exports